/**
 * Cinematic look presets — tuned for window-sun contrast + magazine color grade.
 *
 * Local HDR: public/images/skybox/2_1k.hdr (~1.3MB).
 */

export const LOOK = {

  DAY: 'day',
  EVENING: 'evening',

}

/** Active look — change to LOOK.EVENING for warm evening grade */
export const ACTIVE_LOOK = LOOK.DAY;

export const LOOK_PRESETS = {

  [ LOOK.DAY ]: {

    // Slightly under 1.1 so white stretch ceiling / light walls don't clip
    exposure: 0.98,
    background: '#c5d0dc',

    sunPosition: [ 40, 28, -90 ],

    environment: {

      files: '/images/skybox/2_1k.hdr',
      background: false,

    },

    /** Reflections on sill / varnish without washing sun patches */
    envMapIntensity: 0.48,

    hemisphere: {

      skyColor: '#c9daf0',
      groundColor: '#7a6a58',
      intensity: 0.08,

    },

    ambientScale: 0.55,
    directionalScale: 2.05,
    spotScale: 0.85,
    directionalColor: '#ffe7c4',
    spotColor: '#dfe9ff',

    exterior: {

      // Winter overcast — no city, soft snow horizon
      skyTurbidity: 8.5,
      skyRayleigh: 0.3,
      groundColor: '#e8eef5',

    },

    grade: {

      brightness: 0.0,
      contrast: 0.1,
      saturation: 0.08,
      hue: 0.01,

    },

    postfx: {

      enabled: true,
      ssao: { enabled: false, samples: 16, radius: 12, intensity: 8, luminanceInfluence: 0.45 },
      bloom: { luminanceThreshold: 0.82, luminanceSmoothing: 0.45, intensity: 0.32 },
      vignette: { offset: 0.2, darkness: 0.42 },

    },

  },

  [ LOOK.EVENING ]: {

    exposure: 0.88,
    background: '#c4a888',

    sunPosition: [ -30, 12, -70 ],

    environment: {

      files: '/images/skybox/2_1k.hdr',
      background: false,

    },

    envMapIntensity: 0.38,

    hemisphere: {

      skyColor: '#f0c9a0',
      groundColor: '#5c4334',
      intensity: 0.06,

    },

    ambientScale: 0.45,
    directionalScale: 1.7,
    spotScale: 0.7,
    directionalColor: '#ff9a55',
    spotColor: '#ffd8b0',

    exterior: {

      skyTurbidity: 10,
      skyRayleigh: 0.25,
      groundColor: '#d5dde8',

    },

    grade: {

      brightness: -0.01,
      contrast: 0.16,
      saturation: 0.12,
      hue: 0.02,

    },

    postfx: {

      enabled: true,
      ssao: { enabled: false, samples: 16, radius: 12, intensity: 8, luminanceInfluence: 0.4 },
      bloom: { luminanceThreshold: 0.72, luminanceSmoothing: 0.4, intensity: 0.55 },
      vignette: { offset: 0.18, darkness: 0.5 },

    },

  },

}

export function getLookPreset( look = ACTIVE_LOOK ) {

  return LOOK_PRESETS[ look ] || LOOK_PRESETS[ LOOK.DAY ];

}
